<template>
  <el-select
    v-model="selectValue"
    :placeholder="placeholder"
    :disabled="disabled"
    :multiple="multiple"
    :clearable="clearable"
    :size="size"
    @change="handleChange"
  >
    <el-option
      v-for="item in dictOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value"
      :disabled="item.disabled"
    />
  </el-select>
</template>

<script>
import { computed, ref, watch } from 'vue'
import { getDictOptions } from '@/utils/dict'

export default {
  name: 'DictSelect',
  props: {
    // 字典类型
    dictCode: {
      type: String,
      required: true
    },
    // 绑定值
    modelValue: {
      type: [String, Number, Array],
      default: ''
    },
    // 占位符
    placeholder: {
      type: String,
      default: '请选择'
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // 是否多选
    multiple: {
      type: Boolean,
      default: false
    },
    // 是否可清空
    clearable: {
      type: Boolean,
      default: true
    },
    // 组件尺寸
    size: {
      type: String,
      default: 'default'
    }
  },
  emits: ['update:modelValue', 'change'],
  setup(props, { emit }) {
    // 选择值
    const selectValue = ref(props.modelValue)
    
    // 字典选项
    const dictOptions = computed(() => {
      return getDictOptions(props.dictCode)
    })
    
    // 监听值变化
    watch(
      () => props.modelValue,
      (val) => {
        selectValue.value = val
      }
    )
    
    // 处理选择变化
    const handleChange = (val) => {
      emit('update:modelValue', val)
      emit('change', val)
    }
    
    return {
      selectValue,
      dictOptions,
      handleChange
    }
  }
}
</script> 